const C = require("../constants");
const initial_data = {total_sale: 0, payments: 0, amount: 0, discount: 0, balance: 0, taxes:[]};

function TotalSaleReducer(state = initial_data, action) {
    switch (action.type) {
        case C.TOTAL_SALE:
            return action.total_sale;
        default:
            return state;
    }
}

export default TotalSaleReducer;


// WEBPACK FOOTER //
// ./src/reducers/TotalSaleReducer.js